(function (){
    'use strict';
    angular
        .module('authService', [])
        .factory('authService', authService);

    authService.$inject = ['$http', '$localStorage'];

    function authService ($http, $localStorage){
        const ENDPOINT = 'api/v1/auth';
        const PROTOCOL = location.host !== 'localhost' ? 'https:' : 'http:'
        const ORIGIN = `${PROTOCOL}//${location.host}`

        let vm = this;
        vm.login = login;
        vm.register = register;
        vm.checkEmailExists = checkEmailExists;
        vm.resetPassword = resetPassword;
        vm.updatePassword = updatePassword;
        return vm;

        function login (email, password){
            const params = {email, password, action: 'login'}

            const nextParam = location.search.split('next=')[1];
            if(nextParam !== undefined){
                params['next'] =
                    decodeURIComponent(nextParam).substring(0,1)==='/' ?
                    decodeURIComponent(nextParam).substring(1) :
                    decodeURIComponent(nextParam);
            }

            return $http
                .get(ENDPOINT, {params})
                .then(_loginResponseHandler)
                .catch(_loginResponseHandler)

            function _loginResponseHandler (response) {
                let {status, data} = response;
                if (status === 201) {
                    let {api_key, url} = data;
                    $localStorage.api_key = api_key;
                    return {success: true, next: `${ORIGIN}${url.startsWith('/') ? url : '/' + url}`}
                }
                let errorMessage = 'Lütfen daha sonra tekrar deneyin.'
                if (status === 401) {
                    errorMessage = 'Email ve/veya şifreniz hatalı!'
                } else if (status === 403) {
                    errorMessage = 'Kullanıcınız aktif değildir. Sistem yöneticiniz ile iletişime geçiniz.'
                }
                return {
                    success: false,
                    message: errorMessage
                }
            }
        }

        function checkEmailExists (email){
            const params = {email, action: 'check_email'}

            return $http.get(ENDPOINT, {params}).then(({data}) => {return data}).catch(() => { return false })
        }

        function resetPassword (email){
            const params = {email, action: 'forget_password'}

            return $http
                .get(ENDPOINT, {params})
                .then(_resetPasswordResponseHandler)
                .catch(_resetPasswordResponseHandler)

            function _resetPasswordResponseHandler (response) {
                let {status, data} = response;
                let isSuccess,
                    errorMessage = 'Lütfen daha sonra tekrar deneyin.';

                if (status === 201 || status === 200) {
                    isSuccess = true;
                } else if (status === 404) {
                    isSuccess = false;
                    errorMessage = data
                } else {
                    isSuccess = false;
                    errorMessage = 'Beklenmedik bir hata oluştu'
                }
                return {
                    success: isSuccess,
                    message: errorMessage
                }
            }
        }

        function updatePassword ({email, password, passwordRec}){
            const params = {email, password, passwordRec}

            return $http
                .put(ENDPOINT, {data: params})
                .then(_updatePasswordResponseHandler)
                .catch(_updatePasswordResponseHandler)

            function _updatePasswordResponseHandler (response) {
                let {status, data} = response;
                let isSuccess = false,
                    errorMessage = 'Lütfen daha sonra tekrar deneyin.';

                if (status === 201 || status === 200) {
                    isSuccess = true;
                } else if (status > 500) {
                    errorMessage = 'Beklenmedik bir hata oluştu'
                } else {
                    errorMessage = 'Şifre sıfırlama anahtarı geçersiz veya hatalı'
                }
                return {
                    success: isSuccess,
                    message: errorMessage
                }
            }
        }

        function register (formData) {
            return $http
                .post(ENDPOINT, {data: formData})
                .then(_registerResponseHandler)
                .catch(_registerResponseHandler)

            function _registerResponseHandler (response) {
                let {status, data} = response;
                let {result, detail} = data || {};

                let isSuccess = false,
                    errorMessage;

                if (status === 201) {
                    isSuccess = true;
                } else {
                    errorMessage = detail || data || 'Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyin.'
                }
                return {
                    success: isSuccess,
                    message: errorMessage
                }
            }
        }

    }
})();